import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { AddButtonComponent } from "@components/add-button/add-button.component";
import { ToggleItemTextVisibilityButtonComponent } from "@components/toggle-item-text-visibility-button/toggle-item-text-visibility-button.component";
import { ToggleLockButtonComponent } from "@components/toggle-lock-button/toggle-lock-button.component";
import { ToggleVisibilityButtonComponent } from "@components/toggle-visibility-button/toggle-visibility-button.component";
import { FloorplanState } from "@domain/project/floorplan/floorplan-state";
import { FloorplanMenuItemButtonsComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-item-buttons/floorplan-menu-item-buttons.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-floorplan-protective-tubes-menu",
  imports: [
    AddButtonComponent,
    FloorplanMenuItemButtonsComponent,
    ToggleLockButtonComponent,
    ToggleVisibilityButtonComponent,
    UiKitModule,
    ToggleItemTextVisibilityButtonComponent,
  ],
  templateUrl: "./floorplan-protective-tubes-menu.component.html",
  styleUrl: "./floorplan-protective-tubes-menu.component.scss",
})
export class FloorplanProtectiveTubesMenuComponent {
  private floorplanService = inject(FloorplanService);
  private dragDropService = inject(FloorplanDragDropService);

  protected floorplanState: FloorplanState;

  protected readonly tooltipTextAddProtectiveTube: string = $localize`:@@floorplan.button.addProtectiveTube:Neues Schutzrohr hinzufügen`;

  constructor() {
    this.floorplanState = this.floorplanService.selectedFloorplan.floorplanState;
  }

  addProtectiveTube() {
    this.floorplanService.addProtectiveTube();
  }

  dragProtectiveTube() {
    this.dragDropService.setDragged({ type: DraggedItemType.PROTECTIVE_TUBE });
  }

  protected updateProtectiveTubesItemTextVisibility(visible: boolean) {
    this.floorplanState.updateProtectiveTubesItemTextVisibility(visible);
  }
}
